import * as React from 'react';
export const IcShadow2 = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.49 15.33a8.19 8.19 0 001.76-5.08C18.25 5.7 14.55 2 10 2s-8.25 3.7-8.25 8.25a8.24 8.24 0 002.91 6.28C3.62 17.09 3 17.77 3 18.5c0 1.93 4.25 3.5 9.5 3.5s9.5-1.57 9.5-3.5c0-1.41-2.26-2.62-5.51-3.17zM3.75 10.25C3.75 6.8 6.55 4 10 4s6.25 2.8 6.25 6.25-2.8 6.25-6.25 6.25-6.25-2.8-6.25-6.25z'
      fill='currentColor'
    />
  </svg>
);
